import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=0514dd6a&scoped=true"
import script from "./VehicleInfo.vue?vue&type=script&lang=js"
export * from "./VehicleInfo.vue?vue&type=script&lang=js"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&id=0514dd6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514dd6a",
  null
  
)

export default component.exports